import { WSService } from "../../../utils/WSService";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";

const service = new WSService("/v2/onboarding/acknowledgements");

export const getAcknowledgement = async (
  acknowledgementName: onboardingApiSpec.operations["getAcknowledgement"]["parameters"]["path"]["acknowledgementName"]
): Promise<
  onboardingApiSpec.operations["getAcknowledgement"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.get("/" + acknowledgementName);
  return data;
};

export const updateAcknowledgement = async (
  acknowledgementName: onboardingApiSpec.AcknowledgementName,
  requestBody: onboardingApiSpec.operations["updateAcknowledgement"]["requestBody"]["content"]["application/json"]
): Promise<
  onboardingApiSpec.operations["updateAcknowledgement"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.post("/" + acknowledgementName, requestBody);
  return data;
};
